import { useRef, useContext, useEffect, useState } from 'react';
import { GlobalMobileContext } from '../contexts/globalMobileContext';
import { GlobalContext } from '../contexts/globalContext';
import { ApiLoginMobileUser } from '../utils/RestServices';
import './Mobile_LoginComponent.css';

const Mobile_LoginComponent = ({ email = '' }) => {

    const inputUserNameRef = useRef()
    const inputPasswordRef = useRef()

    const { setCurrentUser, setSocketToken } = useContext(GlobalMobileContext);

    const { setAlertMessage } = useContext(GlobalContext)

    useEffect(() => {
        if (email && inputUserNameRef.current) {
            inputUserNameRef.current.value = email;
        }
        if (inputPasswordRef.current) {
            inputPasswordRef.current.value = '';
        }
    }, [email]);

    function login() {
        if (inputUserNameRef.current.value && inputPasswordRef.current.value) {
            var body = JSON.stringify({
                email: inputUserNameRef.current.value,
                password: inputPasswordRef.current.value
            });

            ApiLoginMobileUser(body, data => {
                if (!data.error) {
                    setCurrentUser(data.response);
                    setSocketToken(data.response.token);
                } else {
                    setAlertMessage({ type: "ERROR", message: data.message });
                }
            })

        } else {
            setAlertMessage({ type: "ERROR", message: "Credentials required" });
        }
    }

    return (
        <main className='login-bg'>
            <div className="container login-container">
                <section className="section register login-full-height d-flex flex-column align-items-center justify-content-center py-4">
                    <h5 className="card-title text-center pb-0 login-title-text">Quick Edit</h5>
                    <h5 className="card-title text-center pb-0 login-subtitle-text">The mobile place to edit notes and files from your Presentations and Conferences</h5>
                    <div className="container ">
                        <div className="row justify-content-center  ">
                            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                <div className="d-flex justify-content-center py-4">
                                    <a href="index.html" className="logo d-flex align-items-center w-auto">
                                        <img src="img/logo-tek-black.svg" alt="" />
                                    </a>
                                </div>

                                <div className="card mb-3 login-box">

                                    <div className="card-body">


                                        <p className="small login-text">Login</p>

                                        <div className="row g-3 needs-validation">

                                            <div className="col-12">
                                                <label className="form-label login-subtext">Username</label>
                                                <div className="input-group has-validation">
                                                    <input ref={inputUserNameRef} type="text" name="username" className="form-control input-box" id="yourUsername" required />
                                                    <div className="invalid-feedback">Please enter your username.</div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <label className="form-label login-subtext">Password</label>
                                                <input ref={inputPasswordRef} type="password" name="password" className="form-control input-box" id="yourPassword" required />
                                                <div className="invalid-feedback">Please enter your password!</div>
                                            </div>


                                            <div className="col-12">
                                                <button className="btn w-100 login-button" onClick={() => login()}>Login</button>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
}

export default Mobile_LoginComponent;